import { takeEvery, call, put } from 'redux-saga/effects';
import { apiManager } from 'infrastructure/api';
import browserHistory from 'infrastructure/history';
import { deleteCookie } from 'infrastructure/security/cookies';

export function* logoutUser() {
  yield put({
    type: 'CLEAR_AUTH',
  });

  yield put(apiManager.api.app.auth.logout());
  deleteCookie('app');

  yield call(() => browserHistory.replace('/login'));
}

function* handleAuthEror() {
  yield logoutUser();
}

function* refreshToken() {
  if (apiManager) {
    yield put(apiManager.api.app.auth.refresh());
  }
}

function* sagas() {
  yield takeEvery(
    x =>
      x.type === 'API_FAILURE' &&
      (x.payload.status === 401 || x.payload.status === 403) &&
      x.meta.type !== 'app/auth/LOGIN' &&
      x.meta.type !== 'app/auth/EXTERNAL_PROVIDER_LOGIN',
    handleAuthEror
  );

  yield takeEvery(
    x =>
      x.type === 'API_SUCCESS' &&
      !x.meta.type.includes('auth') &&
      x.meta.type !== 'app/user/GET_USER_INFO' &&
      x.meta.type !== 'app/publicTikTokCampaign/GET' &&
      x.meta.type !== 'app/dashboard/GET' &&
      x.meta.type !== 'app/dashboard/GET_RELEASE' &&
      x.meta.type !== 'app/dashboard/GET_NARRATIVE',
    refreshToken
  );
}

export default sagas;
